import { Navigate, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/flows/authorize-external/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Navigate
      to="/flows/authorize-external/choose-project"
      search={Route.useSearch()}
    />
  );
}
